import type { Message } from "@whatslly/types/instant-messaging/WhatsappTypes";
import type { WhatsAppApi } from "./injectWhatsappApi";
import type { WhatsappSelectorsType } from "@whatslly/types/integrations/im/WhatsappGetSelectorsResponse";
import get from "lodash/get";
declare const window: {
  importNamespace: (module: string) => any;
  Debug?: {
    VERSION?: string;
  };
};

export const getNamespace = (names: string[]) => {
  const name = names.find((name) => window.importNamespace(name)) as any;
  return window.importNamespace(name);
};

let injeted: WhatsAppApi | undefined;
export function injectWhatsappApiComet(selectors: WhatsappSelectorsType): WhatsAppApi {
  if (injeted) return injeted;
  const WAWebCallCollection = getNamespace(selectors.WAWebCallCollection?.find ?? ["WAWebCallCollection"]);
  const WAWebChatCollection = getNamespace(selectors.ng?.WAWebChatCollection?.find ?? ["WAWebChatCollection"]);
  const WAWebChatLoadMessages = getNamespace(selectors.ng?.WAWebChatLoadMessages?.find ?? ["WAWebChatLoadMessages"]);
  const WAWebDownloadManager = getNamespace(selectors.ng?.WAWebDownloadManager?.find ?? ["WAWebDownloadManager"]);
  const WAWebClock = getNamespace(selectors.ng?.WAWebClock?.find ?? ["WAWebClock"]);
  const WAWebMsgCollection = getNamespace(selectors.ng?.WAWebMsgCollection?.find ?? ["WAWebMsgCollection"]);
  const WAWebApiMessageInfoStore = getNamespace(selectors.ng?.WAWebApiMessageInfoStore?.find ?? ["WAWebApiMessageInfoStore"]);
  const WAWebNewsLetter = getNamespace(selectors.ng?.WAWebNewsLetter?.find ?? ["WAWebNewsletterCollection"]);
  const WAWebMmsClientFormatDownloadUrl = getNamespace(selectors.getSignedUrl.namespace ?? ["WAWebMmsClientFormatDownloadUrl"]);
  const WAWebMmsOperationsConst = getNamespace(selectors.mmsOperationsConst.namespace ?? ["WAWebMmsOperationsConst"]);
  const WAWebMediaHosts = getNamespace(selectors.getHostsInfo.namespace ?? ["WAWebMediaHosts"]);
  const WAWebMmsClientSelectHost = getNamespace(selectors.selectMediaHost.namespace ?? ["WAWebMmsClientSelectHost"]);
  const WAWebStatusCollection = getNamespace(selectors.status.find ?? ["WAWebStatusCollection"]);
  const WAWebApiContact = getNamespace(selectors.ng?.WAWebApiContact?.find ?? ["WAWebApiContact"]);
  const WAWebNotificationTone = getNamespace(selectors.ng?.WAWebNotificationTone?.find ?? ["WAWebNotificationTone"]);

  const whatsappAPI: WhatsAppApi = {
    Chat: get(WAWebChatCollection, selectors.ng?.WAWebChatCollection?.module ?? "ChatCollection"),
    ConversationMsgs: WAWebChatLoadMessages,
    Downloads: get(WAWebDownloadManager, selectors.ng?.WAWebDownloadManager?.module ?? "downloadManager"),
    Clock: get(WAWebClock, selectors.ng?.WAWebClock?.module ?? "Clock"),
    MessageInfo: {
      sendQueryMsgInfo: (message: Message) => {
        return WAWebApiMessageInfoStore.queryMsgInfo(message);
      },
    },
    Contact: {
      getModelsArray: () => {
        return get(WAWebChatCollection, selectors.ng?.WAWebChatCollection?.module ?? "ChatCollection")
          .getModelsArray()
          .map((a: any) => a.contact);
      },
      get: async (lid: string) => {
        const WAWebCollectionsDefault = get(
          getNamespace(selectors.ng?.WAWebCollections?.find ?? ["WAWebCollections"]),
          selectors.ng?.WAWebCollections?.module ?? "default"
        );
        return await WAWebCollectionsDefault.Contact.get(lid);
      },
    },
    WAWebNotificationTone: WAWebNotificationTone,
    Group: {
      queryAllGroups: async () => {
        const WAWebGroupQueryJob = getNamespace(selectors.ng?.WAWebGroupQueryJob?.find ?? ["WAWebGroupQueryJob"]);
        return await get(WAWebGroupQueryJob, selectors.ng?.WAWebGroupQueryJob?.module ?? "default").queryAllGroups();
      },
    },
    Msg: get(WAWebMsgCollection, selectors.ng?.WAWebMsgCollection?.module ?? "MsgCollection"),
    NewsLetter: get(WAWebNewsLetter, selectors.ng?.WAWebNewsLetter?.module ?? "default"),
    Media: {
      getSignedUrl: get(WAWebMmsClientFormatDownloadUrl, selectors.getSignedUrl.module ?? "default"),
      operations: get(WAWebMmsOperationsConst, selectors.mmsOperationsConst.module ?? "default"),
      mediaHosts: get(WAWebMediaHosts, selectors.getHostsInfo.module ?? "mediaHosts"),
      selectHost: get(WAWebMmsClientSelectHost, selectors.selectMediaHost.module ?? "default"),
    },
    Status: get(WAWebStatusCollection, "StatusCollection"),
    Utils: {
      lidToUser: get(WAWebApiContact, selectors.ng?.WAWebApiContact?.getPhoneNumber ?? "getPhoneNumber"),
      userToLid: get(WAWebApiContact, selectors.ng?.WAWebApiContact?.getCurrentLid ?? "getCurrentLid"),
    },
    CallCollection: get(WAWebCallCollection, selectors.WAWebCallCollection?.module ?? "default"),
  };
  injeted = whatsappAPI;
  return whatsappAPI;
}
